import { PlusOutlined, DeleteOutlined, CalendarOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Button, Space, Popover, Popconfirm, Input, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { format } from 'date-fns';
import config from '../../config';
import { useSelector } from 'react-redux';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton, NdoeResponsiveTable, NdoeDataCard,
} from '../../components/ndoe';

const Livraison = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const user = useSelector((state) => state.user?.currentUser);
    const isAdmin = user?.role === 'admin';

    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/livraison`);
        setData(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DOMAIN]);

    const handleDelete = async (id) => {
      try {
        await axios.delete(`${DOMAIN}/api/livraison/livraisonDelete/${id}`);
        fetchData();   // refetch au lieu de recharger toute la page
      } catch (err) {
        console.log(err);
      }
    };

    const columns = [
      { title: '#', dataIndex: 'id', key: 'id', render: (t, r, index) => index + 1, width: "3%" },
      {
        title: 'Date de livraison', dataIndex: 'date_livre', key: 'date_livre',
        render: (text) => <Tag color="blue" icon={<CalendarOutlined />}>{format(new Date(text), 'dd-MM-yyyy')}</Tag>,
      },
      { title: 'Créé par', dataIndex: 'username', key: 'username' },
      {
        title: 'Action', key: 'action',
        render: (text, record) => (
          <Space size="middle">
            {isAdmin &&
            <Popover title="Supprimer" trigger="hover">
              <Popconfirm title="Êtes-vous sûr de vouloir supprimer?" onConfirm={() => handleDelete(record.id)} okText="Oui" cancelText="Non">
                <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
              </Popconfirm>
            </Popover>}
          </Space>
        ),
      },
    ];

    const filteredData = data?.filter((item) =>
      String(item.username ?? '').toLowerCase().includes(searchValue.toLowerCase()) ||
      String(item.date_livre ?? '').toLowerCase().includes(searchValue.toLowerCase())
    );

    const renderCard = (record) => (
      <NdoeDataCard
        title={record.date_livre ? `Livraison du ${format(new Date(record.date_livre), 'dd-MM-yyyy')}` : 'Livraison'}
        subtitle={record.username ? `Créé par ${record.username}` : undefined}
        actions={isAdmin ? [
          <Popconfirm key="d" title="Supprimer cette livraison ?" onConfirm={() => handleDelete(record.id)} okText="Oui" cancelText="Non">
            <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
          </Popconfirm>,
        ] : []}
      />
    );

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Logistique"
        title="Livraisons"
        subtitle="Gérer et suivre les livraisons"
        actions={
          <NdoeActionButton variant="primary" icon={<PlusOutlined />} onClick={() => navigate('/livraisonForm')}>
            Créer une livraison
          </NdoeActionButton>
        }
      />

      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Rechercher (date, auteur)…"
            allowClear
          />
        }
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 8 }}
        renderCard={renderCard}
        empty={{ icon: '🚚', title: 'Aucune livraison', text: 'Créez une nouvelle livraison.' }}
      />
    </NdoePage>
  )
}

export default Livraison
